module.exports = __webpack_public_path__ + "img/img-hyf-8.fcad6fc8.png";